<template>
    <div id="panel_dashboard" class="panel">
        <div class="panel-hdr bg-primary-500 bg-success-gradient">
            <h2>
                Мій кабінет
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        
        <div class="panel-container show">
            <div class="panel-content shadow">
                
                <BOverlay :show="is_load">
                    <BTabs content-class="mt-3">
                        <BTab v-for="(tab,index) in tabs"
                               :title="get_tab_title(tab)"
                               :key="index"
                               :active="tab.is_active"
                        >
                            <template #title>
                                {{get_tab_title(tab)}}
                                <BSpinner type="grow" small v-if="tab.is_load"></BSpinner>
                            </template>
                            
                            <component @loading="set_loading" v-bind:is="tab.index"></component>
                        </BTab>
                    </BTabs>
                </BOverlay>
            </div>
        </div>
    </div>
</template>


<script>

import {
    BOverlay ,
    BTabs,
    BTab,
    BSpinner,
} from 'bootstrap-vue-next';

import profile_edit from "./tabs/profile_edit.vue";
import profile_subscribe from "./tabs/profile_subscribe.vue";
import profile_files from "./tabs/profile_files.vue";

export default {
    name: "user_profile",
    components : {
        BOverlay,
        BTabs,
        BTab,
        BSpinner,
        
        profile_edit,
        profile_subscribe,
        profile_files
    },

 
    
    data () {
        return {
            is_load: false,
            tabs: [
                {
                    index : "profile_edit",
                    title : "Редагувати профіль"
                },
                
                {
                    index : "profile_subscribe",
                    title : "Анонси Тендерів"
                },
              
                {
                    index : "profile_files",
                    title : "Завантажити документи"
                },
            ],
        }
    },
    methods : {
        
        set_loading(tab,state) {
            if(state === true) {
                IMC_CORE.showloading();
            }
            else {
                IMC_CORE.hideloading();
            }
        },
        
        get_tab_title(tab) {
            if (tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },
        
        set_active(obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },
        
    }
}
</script>


<style scoped>

</style>